<template>
  <div>
    <!-- Modal Component -->
    <b-modal
      id="forgot-password-modal"
      title="Forgot Password"
      centered
    >
      <div
        id="forgot-password-input-container"
        class="form-group"
      >
        <label for="username-label">Email address</label>
        <b-form-input
          v-model="email"
          v-b-tooltip.hover
          class="form-control"
          placeholder="Your sky email address"
          :state="emailState"
          title="Press Enter to submit"
          :formatter="format"
          style="margin-bottom: 0;"
          @keyup.enter.native="clickedSendVerificationCode()"
        />
        <div
          v-show="!emailState"
          style="font-size: 10pt; color: red; margin-top: 0.5rem; margin-bottom: 1rem; text-align: left;"
        >
          Your email needs to be ending with @sky.uk, @sky.de, @sky.at or @iwedia.com
        </div>
      </div>
      <b-alert
        variant="danger"
        dismissible
        :show="is_email_wrong"
        @dismissed="is_email_wrong=false"
      >
        Not a valid Sky email address. Please use your Sky email address or contact your line manager to request access
      </b-alert>
      <div
        slot="modal-footer"
        class="w-100"
      >
        <b-btn
          id="footer-button"
          size="xl"
          :disabled="!emailState || is_loading"
          variant="primary"
          :enabled="!is_loading && emailState"
          @click="clickedSendVerificationCode()"
        >
          <i
            v-show="is_loading"
            class="fa fa-spinner fa-spin"
          /> Send Verification Code
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import bModal from 'bootstrap-vue/es/components/modal/modal'
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'

import bAlert from 'bootstrap-vue/es/components/alert/alert'

import utils from '../../utils.js'

import USER_API from '../../api/user'
import { EVENT_RESET_PASSWORD_EMAIL } from '../../constants'

export default {
	deubg: false,
	props: {
		initialEmail: {
			type: String,
			required: true
		}
	},

	data () {
		return {
			email: this.initialEmail,
			is_email_wrong: false,
			is_loading: false
		}
	},

	computed: {
		emailState () {
			return utils.validateEmail(this.email)
		}
	},

	// We watch the props being changed and update the email accordingly
	watch: {
	  	initialEmail: {
	    	handler: function (initialEmail) {
	      		this.email = this.initialEmail
	    	},
	    	immediate: true
		}
	},

	mounted () {
		console.debug('Mounted ForgotPasswordComponent', this.initialEmail)
	},

	methods: {
		format: function (value, event) {
			return value.toLowerCase()
		},

		clickedSendVerificationCode: function () {
			console.log('this.email : ' + this.email)

			if (!this.is_loading) {
				if (utils.validateEmail(this.email)) {
					this.is_email_wrong = false
					this.is_loading = true

					const params = {
						email: this.email
					}

					const reference = this

					USER_API.forgot_password(params,
						() => {
				        	reference.is_loading = false

				        	reference.$root.$emit('bv::hide::modal', 'forgot-password-modal')

							utils.makeToast(reference.$bvToast, 'Success', 'success', 'Now you need to enter the code')

		                    reference.$emit(EVENT_RESET_PASSWORD_EMAIL, reference.email)

				            reference.$root.$emit('bv::show::modal', 'reset-password-modal')
						},
						e => {
							console.debug(e)

							reference.is_loading = false

							if (e.hasOwnProperty('response')) {
								const response = e['response']

								if (response != undefined) {
									if (response.hasOwnProperty('data')) {
										const data = response['data']

										if (data.hasOwnProperty('error')) {
											const error = data['error']
											utils.makeToast(reference.$bvToast, 'Error', 'danger', error)

											return
										}
									}
								}
							}
							utils.makeToast(reference.$bvToast, 'Error', 'danger', "A problem occured with the check of your verification code, make sure it's the correct")
						}
					)
				} else {
					console.log('Invalid email ')

					this.is_email_wrong = true
				}
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
h1
	color: green

#footer-button
	width: 100%
	padding: 0.4rem
	font-size: 14pt

#forgot-password-input-container
	text-align: left
</style>
